<template>
  <div class="port-item">
    <div class="port-item-icon">
      <span>
        <img :src="icon">
      </span>
      <p>{{ title }}</p>
    </div>
    <p class="port-item-value">
      {{ value }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'PortItem',
  props: {
    title: {
      type: String,
      default: () => ''
    },
    value: {
      type: String,
      default: () => ''
    },
    icon: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style lang="scss" scoped>

.port-item {
  display: flex;
  min-width: 200px;
  &-icon {
    text-align: center;
    padding:0 10px;
    span {
      display: inline-block;
      width: 32px;
      height: 32px;
      vertical-align: text-top;
    }
    p {
      margin: 0;
      font-size: 14px;
    }
  }

  &-value {
    flex: 1;
    height: 54px;
    text-align: center;
    border-bottom: 1px solid #DCDFE6;
    margin: 0 10px;
    padding: 0 20px 14px 20px;
    font-size: 18px;
    line-height: 60px;
  }
}
</style>
